import { InputAdornment } from "@mui/material";

const currencyEndAdornment = {
  InputProps: {
    startAdornment: (
      <InputAdornment position="start" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}>
        $
      </InputAdornment>
    ),
  },
};

export default currencyEndAdornment;
